<script setup>
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Titre from "@/components/atoms/titre";
import Icon from "@/components/atoms/icon";

const props = defineProps({
  carteInvalide: {
    type: Boolean,
    required: false,
    default: false
  },
  message: {
    type: String,
    required: false,
    default: null
  }
});

const emit = defineEmits(["close"]);
</script>

<template>
  <div class="u-flex u-flex-column u-flex-align-center u-mt-xs">
    <Icon
      variant="secondary"
      name="alert-circle-outline"
    />
    <Titre
      tag="h1"
      size="md"
      variant="primary"
      class="u-text-center u-mt-sm u-mb-sm u-mb-xs@md u-my-lg@xs"
    >
      Une erreur est survenue
    </Titre>
    <p class="u-text-center u-px-lg u-mb-sm u-mb-lg@xs">
      {{ message ?? "Nous rencontrons actuellement des difficultés lors du traitement de votre commande. Merci de réessayer ultérieurement" }}
    </p>
    <div class="u-flex u-flex-justify-center u-flex-align-center u-gap-sm">
      <Button
        size="lg"
        radius="full"
        variant="primary"
        class="u-mb-sm"
        @click="emit('close')"
      >
        Retour au paiement
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
